import { Component, input } from '@angular/core';
import { PrimaryGaragesInfo } from 'src/app/models/vehicle.model';

@Component({
  selector: 'app-preferred-garage-card',
  templateUrl: './preferred-garage-card.component.html',
  styleUrls: ['./preferred-garage-card.component.scss'],
  standalone: false,
})
export class PreferredGarageCardComponent {
  /* List of preferred garages displayed in the card */
  primarygaragesInfo = input<PrimaryGaragesInfo[]>([]);

}
